import styled from "@emotion/styled";

export const COLORS = {
  /* Brand Accent */
  accent: "#5E84ED", // -- accent primary
  btnHover: "#2457E3", // -- accent pressed
  link: "#8FB0FF", // -- accent hover/links
  accentGlow: "rgba(94,132,237,0.15)",

  /* Neutrals (dark scale) */
  appBg: "#1A1A1C", // -- neutral canvas
  surface: "#1E1F22", // -- neutral surface
  card: "#26282D", // -- neutral raised
  cardElevated: "#2B2D33", // -- neutral depth
  neutralOverlay: "rgba(255,255,255,0.05)",

  /* Text */
  textPrimary: "#E9ECF5", // -- text primary
  textSecondary: "#C5CAD6", // -- text secondary
  textMuted: "#B7BDCB", // -- text muted
  textPlaceholder: "#7D8493", // -- text placeholder
  onPrimary: "#FFFFFF", // -- text/inverse

  /* Feedback */
  danger: "#D65F46", // -- danger
  dangerPressed: "#9E3D2C", // -- pressed (danger pressed)
  success: "#3FCF9B", // -- success
  warning: "#E6B76A", // -- warning

  /* Utility */
  border: "#2B2D33", // -- border 300
  divider: "#2B2D33", // -- divider 300
  shadowOverlay: "rgba(0,0,0,0.40)", // -- shadow overlay
  scrim50: "rgba(0,0,0,0.50)", // -- scrim 50

  /* Legacy / app-specific (kept for compatibility) */
  sidebar: "#24262A",
  sidebarBorder: "#2B2D33",
  primaryContainer: "#273258",
  onPrimaryContainer: "#E9ECF5",
  btnRest: "#406CE7",
  btnActive: "#1A49CF",
  btnText: "#FFFFFF",
  btnDisabled: "#2A2A2E",
  outline: "#343844",
  focusRing: "#98B3FF",
};

export const s = (n: number) => `${n * 8}px`;

export const HeaderSpacer = styled.div({
  height: "calc(56px + env(safe-area-inset-top, 0px))",
  flexShrink: 0,
});

export const HeaderContainer = styled.header({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: s(2),
  padding: `calc(env(safe-area-inset-top, 0px) + 6px) 16px 6px 16px`,
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  background: COLORS.appBg,
  borderTop: `0px solid ${COLORS.border}`,
  borderRight: `0px solid ${COLORS.border}`,
  borderBottom: `1px solid ${COLORS.border}`,
  borderLeft: `0px solid ${COLORS.border}`,
});

export const HamburgerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
`;

export const PlanPill = styled.span({
  fontFamily: "Inter",
  fontWeight: "500",
  fontSize: "12px",
  width: "120px",
  height: "28px",
  color: "#B7BDCB",
  borderRadius: 999,
  background: COLORS.surface,
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  position: "relative",
  marginLeft: "36px",
  "&:before": {
    content: '""',
    width: 5,
    height: 5,
    borderRadius: 999,
    background: COLORS.accent,
    boxShadow: `0 0 0 2px ${COLORS.accent}40 inset`,
    display: "inline-block",
    marginRight: 0,
    marginLeft: 10,
  },
});

export const RightActions = styled.div({
  display: "flex",
  alignItems: "center",
  gap: s(2),
  flex: "0 0 auto",
});

export const IconButton = styled.button({
  width: s(4),
  height: s(4),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 10,
  background: "none",
  border: `none`,
  color: COLORS.textSecondary,
  transition:
    "transform 150ms ease, background 150ms ease, box-shadow 150ms ease",
  cursor: "pointer",
  "&:hover": { transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
});

export const NavTitle = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: #e9ecf5;
  margin: 0;
`;
